// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subContent {
  padding: 20px 10px;
}

.appLandingPage {
  background-image: var(--landing-bg-img);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 116vh; /* Makes the height fit the screen */
  overflow-y: scroll; /* Allows vertical scrolling */
  scrollbar-width: none; /* Hides scrollbar in Firefox */
  margin-bottom: 0px !important;
}
.appLandingPage .appInnerBlock {
  z-index: 99;
  position: relative;
  display: flex;
  justify-content: center;
}

.appLandingPage::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(180, 176, 176, 0.3019607843); /* Light white overlay */
  pointer-events: none; /* Prevents overlay from interfering with interactions */
}

.cardApp {
  display: flex;
  flex-direction: row;
  /* Display content in a row */
  align-items: center;
  color: white;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid rgba(19, 24, 52, 0.5294117647);
}
.cardApp:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 6px 6px rgba(0, 0, 0, 0.168627451);
}
.cardApp h3 {
  margin: 0;
}
.cardApp p {
  font-size: 0.9em;
  margin-top: 5px;
}

/* Styling for the icon or image container */
.icon-container {
  font-size: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  /* Slightly transparent background for icon container */
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app_css/AppLandingPage.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,uCAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA,EAAA,oCAAA;EACA,kBAAA,EAAA,8BAAA;EACA,qBAAA,EAAA,+BAAA;EACA,6BAAA;AACJ;AACI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AACN;;AAGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6CAAA,EAAA,wBAAA;EACA,oBAAA,EAAA,wDAAA;AAAJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;AADJ;AAGI;EACI,2BAAA;EACA,sDAAA;AADR;AAII;EACI,SAAA;AAFR;AAKI;EACI,gBAAA;EACA,eAAA;AAHR;;AAOA,4CAAA;AACA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAEA,uDAAA;AALJ","sourcesContent":[".subContent {\n    padding: 20px 10px;\n}\n\n.appLandingPage {\n    background-image: var(--landing-bg-img);\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n    min-height: 116vh; /* Makes the height fit the screen */\n    overflow-y: scroll; /* Allows vertical scrolling */\n    scrollbar-width: none; /* Hides scrollbar in Firefox */\n    margin-bottom: 0px !important;\n  \n    .appInnerBlock{\n      z-index: 99;\n      position: relative;\n      display: flex;\n      justify-content: center;\n    }\n  }\n  \n  .appLandingPage::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #b4b0b04d; /* Light white overlay */\n    pointer-events: none; /* Prevents overlay from interfering with interactions */\n  }\n  \n\n.cardApp {\n    display: flex;\n    flex-direction: row;\n    /* Display content in a row */\n    align-items: center;\n    color: white;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    border-radius: 8px;\n    cursor: pointer;\n    border: 1px solid #13183487;\n\n    &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0px 6px 6px 6px #0000002b;\n    }\n\n    h3 {\n        margin: 0;\n    }\n\n    p {\n        font-size: 0.9em;\n        margin-top: 5px;\n    }\n}\n\n/* Styling for the icon or image container */\n.icon-container {\n    font-size: 2em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    // background-color: rgba(255, 255, 255, 0.15);\n    /* Slightly transparent background for icon container */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
